// src/api.js
export async function fetchFinancials(rssdId, metric = 'NUMEMP', limit = 100) {
    const url = new URL('https://banks.data.fdic.gov/api/financials');
    url.searchParams.set('filters', `RSSDID: ${rssdId}`);
    url.searchParams.set('fields', ['RSSDID', 'REPDTE', metric].join(','));
    url.searchParams.set('sort_by', 'REPDTE');
    url.searchParams.set('sort_order', 'DESC');
    url.searchParams.set('format', 'json');
    url.searchParams.set('limit', limit);
  
    const res = await fetch(url.toString());
    if (!res.ok) throw new Error(`FDIC API returned status ${res.status}`);
  
    const json = await res.json();
    // Yeni yapı: json.data → [ { data: {REPDTE, RSSDID, NUMEMP, ID}, score }, ... ]
    const raw = Array.isArray(json.data) ? json.data : [];
  
    const series = raw
      .map(item => {
        const row = item.data;
        // Güvenli tarih stringi
        const repdteStr = row.REPDTE != null ? String(row.REPDTE) : null;
        if (!repdteStr || repdteStr.length !== 8) return null;
  
        const year  = parseInt(repdteStr.slice(0, 4), 10);
        const month = parseInt(repdteStr.slice(4, 6), 10) - 1;
        const day   = parseInt(repdteStr.slice(6, 8), 10);
        const value = row[metric];
        if (value == null) return null;
  
        return {
          date: new Date(year, month, day),
          value: Number(value)
        };
      })
      .filter(pt => pt !== null)
      .reverse(); // artan zamana göre
  
    return series;
  }
  